import { render } from "./app-upload-picture-card.vue?vue&type=template&id=b678b0b6&scoped=true&ts=true"
import script from "./app-upload-picture-card.vue?vue&type=script&lang=ts"
export * from "./app-upload-picture-card.vue?vue&type=script&lang=ts"

import "./app-upload-picture-card.vue?vue&type=style&index=0&id=b678b0b6&lang=scss"
import "./app-upload-picture-card.vue?vue&type=style&index=1&id=b678b0b6&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b678b0b6"]])

export default __exports__